import { Button } from '@newfront-insurance/core-ui/v2';

import { OrganizationAdmins } from './organization-admins';
import { useChatOverlayContext } from '../../contexts/chat-overlay-context';
import { SettingsPageHeader } from '../settings-page-header';
import { SettingsPersonRow } from '../settings-person-row';
import { SettingsSectionList } from '../settings-section-list';

export function AdminsSettings() {
  const { settingsAdministration, userUuid } = useChatOverlayContext();
  const { organizations, status, retry } = settingsAdministration;

  return (
    <section aria-labelledby="settings-admins-title" className="flex min-w-0 flex-col gap-6">
      <SettingsPageHeader
        title="Admins"
        titleId="settings-admins-title"
        description="Who can share skills across your organizations."
      />
      {status === 'loading' ? (
        <SettingsSectionList title="Admins" loading>
          <SettingsPersonRow loadingLabel="Loading admins" />
        </SettingsSectionList>
      ) : status === 'error' ? (
        <div role="alert" className="border-steel-75 text-steel-400 rounded-xs border bg-white p-5 text-sm">
          Couldn't load organizations.{' '}
          <Button type="button" variant="inline" className="text-sm" onClick={retry}>
            Retry
          </Button>
        </div>
      ) : organizations.length ? (
        organizations.map((organization) => (
          <OrganizationAdmins key={`${userUuid}:${organization.uuid}`} organization={organization} />
        ))
      ) : (
        <SettingsSectionList title="Admins" emptyMessage="No organizations to display." />
      )}
    </section>
  );
}
